// extracted by mini-css-extract-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1_v8k","cls2":"UserTaggingPingBodyStyles-cls2_RLJ UserTaggingPingBodyStyles-cls1_v8k"};